export default __webpack_public_path__ + "static/poster-0ecd429967e1cc6f56ac13a72a82e671.png";